// tslint:disable
import * as AjaxURL from "../System/AjaxURL";
import _ from "underscore";
import { getBaseURL } from "./Site";

// prettier-ignore
export const init = (): CartegraphGlobal => {

var Cartegraph = {} as CartegraphGlobal;

Cartegraph.FlexUI = {}; //A volatile namespace that will be destroyed on every navigation
Cartegraph.Common = {}; //For Common bits that live in various JS files
Cartegraph.Models = {} as any; //A namespace for javascript business object models
Cartegraph.ViewModels = {} as any; // A namespace for javascript view models that are common.
Cartegraph.Inspections = {} as any; //A namespace for javascript related to Inspections.
Cartegraph.Window = {} as any; //A namespace for the common window dialog.
Cartegraph.Guides = {} as any; //Namespace containing entry points for launching on-screen guided processes.
Cartegraph.activeElementID = {} as any; //Same as document.ActiveElement, should be set in the onmousedown event
Cartegraph.Browser = {} as any; //A namespace for detecting the current browser.
Cartegraph.Summary = {} as any; // A namespace used for summary dialogs
Cartegraph.Map = {} as any; // A namespace used for maps
Cartegraph.Library = {} as any; //A namespace used for Library features
Cartegraph.ImportExport = {} as any; //A namespace used for Import Export features

// Generate an integer hash for the string. Some-guy code, where
// the guy claims it's a port of how Java generates string hashes:
// http://werxltd.com/wp/2010/05/13/javascript-implementation-of-javas-string-hashcode-method
String.prototype.hashCode = function () {
    var hash = 0, i, chr, len;
    if (this.length == 0) return hash;
    for (i = 0, len = this.length; i < len; i++) {
        chr = this.charCodeAt(i);
        hash = ((hash << 5) - hash) + chr;
        hash |= 0; // Convert to 32bit integer
    }
    return hash;
};

/**
 * A Singleton that contains various utility type functions
 */
Cartegraph.Utilities = (function () {
    // Initialize with a random integer so a browser refresh doesn't start at one again
    var mapCacheId = Math.floor(2147483647 - Math.random() * 4294967294);
    var scrollbarWidth: number = null;
    var timeout: number;
    var blockTabs = false;
    var firstTabbableItem: any = null;
    var lastTabbableItem: any = null;
    var blockScreenId: string = null;

    return {

        eControlType: {
            AutoComplete: 1,
            FreeText: 2,
            Number: 3,
            Integer: 4,
            DateTime: 5,
            Date: 6,
            Time: 7,
            YesNo: 8,
            Disabled: 9,
            QuantityUnit: 10,
            UserRole: 11
        },

        eFieldListType: {
            ViewEditDesigner: 1,
            GridColumnSelector: 2,
            FilterFieldChooser: 3,
            NotificationMessageEditor: 4,
            AssetSummaryGridColumnSelector: 5,
            ExportFilterFieldChooser: 6,
            ImportExportRsetFields: 7
        },

      displayClientSideError: function () {
            $('.cgSaveButton').removeAttr('dirtystate');  // re-enable the save button so that dirty field prompts will again appear
            $('.cgSaveButton').removeClass(Cartegraph.Utilities.getActiveNavigationStyle() + "Disabled").addClass('cgSaveButtonActive');

            var buttons = {
                "OK": { text: Cartegraph.Resources.OK,
                    click: function () {
                        $(this).dialog("close");
                    },
                    defaultButton: true
                }
            };
            Cartegraph.Utilities.initDialog(Cartegraph.Resources.SomeFieldsHaveErrors, Cartegraph.Resources.CorrectErrorsToContinue, buttons);
        },

        getActiveNavigationStyle: function () {
            var cssClass;

            var mapper = Cartegraph.URIMapper;

            switch (mapper.currentNavigationTab()) {
                case Cartegraph.URIMap['Assets'].tab:
                    cssClass = 'assetCreateProcess';
                    break;
                case Cartegraph.URIMap['Resources'].tab:
                    cssClass = 'resourcesCreateProcess';
                    break;
                case Cartegraph.URIMap['Work'].tab:
                    cssClass = 'workCreateProcess';
                    break;
                case Cartegraph.URIMap['Requests'].tab:
                    cssClass = 'requestCreateProcess';
                    break;
                case Cartegraph.URIMap['Administration'].tab:
                    cssClass = 'adminCreateProcess';
                    break;
                default:
                    cssClass = 'addChildProcess';
                    if (mapper.isOnInspection())
                        cssClass = 'performInspection';
                    break;
            }
            return cssClass;
        },

        getCurrentClassStyle: function (className: string) {
            var cssClass;

            if (Cartegraph.MetaDataHelpers.isAsset(className))
                cssClass = 'assetCreateProcess';
            else if (Cartegraph.MetaDataHelpers.isResource(className))
                cssClass = 'resourcesCreateProcess';
            else if (Cartegraph.MetaDataHelpers.isRequest(className))
                cssClass = 'requestCreateProcess';
            else if (Cartegraph.MetaDataHelpers.isTask(className))
                cssClass = 'workCreateProcess';
            else
                cssClass = 'addChildProcess';
            return cssClass;
        },

        /* Returns vMin to allow expansion of scientific notation in autonumeric function */
        getVMin: function () {
            return '-170000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000.999999999999999999999999999999999999999999999999999999999999999999999999999999999999999999999999999';
        },

        /* Returns vMax to allow expansion of scientific notation in autonumeric function */
        getVMax: function () {
            return '170000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000.999999999999999999999999999999999999999999999999999999999999999999999999999999999999999999999999999';
        },

        /* Returns a constant that represents the largest possible value of an Int32 */
        getInt32MaxValue: function () {
            return 2147483647;
        },

        // Returns a random integer between min and max
        // Using Math.round() will give you a non-uniform distribution!
        generateRandomInt: function (min: number, max: number) {
            return Math.floor(Math.random() * (max - min + 1) + min);
        },

        getViewType: function () {
            return $('#viewType').val();
        },

        getInitDialogButtonsParamOKButtonOnly: function () {
            return {
                "OK": {
                    text: Cartegraph.Resources.OK,
                    click: function () {
                        $(this).dialog("close");
                    },
                    defaultButton: true
                }
            };
        },

        initDialog: function (title: any, message: string | Element | Comment | DocumentFragment | ((this: HTMLElement, index: number, oldhtml: string) => string | Element | Text | Comment | DocumentFragment), buttons: any, isWarning: boolean, isSuccess: boolean) {
            if (isWarning == null) {
                isWarning = false;
            }

            //only check for success if isWarning is false
            if (!isWarning) {
                if (isSuccess == null) {
                    isSuccess = false;
                }
            }

            if (buttons) {
                $.each(buttons, function (_index, value) {
                    if (value.defaultButton === true && !isWarning && !isSuccess)
                        value["class"] = "cgButton cgButtonButtonSmall cgRedButton";
                    else if (value.defaultButton === true && isWarning)
                        value["class"] = "cgButton cgButtonButtonSmall cgYellowButton";
                    else
                        value["class"] = "cgButton cgButtonButtonSmall cgLightGreyButton";

                    if (value.pendoTag) {
                        value["data-cg"] = value.pendoTag;
                        delete value.pendoTag;
                    }

                    if (value.cypressTag) {
                        value["data-test"] = value.cypressTag;
                        delete value.cypressTag;
                    }
                });
            }

            if (message && !$.isArray(message))
                message = (message as string).replace(/\n/g, '<br />');

            var setDialogClass = "dialogRedWhiteGray";
            if (isWarning)
                setDialogClass = setDialogClass + " YellowWarning";
            else if (isSuccess)
                setDialogClass = setDialogClass + " GreenSuccess";

            //This hooks up our common dialog and returns it read to be invoked
            var dialogBox = $("#dialog").dialog({
                resizable: false,
                draggable: false,
                width: 490,
                modal: true,
                title: title,
                autoOpen: true,
                buttons: buttons,
                zIndex: 99999998,
                dialogClass: setDialogClass,
                open: function () {
                    var theBtn = $(document).find("#RedButton") as any;
                    if (theBtn.length == 0) {
                        theBtn = $(this).siblings('.ui-dialog-buttonpane').find('.cgRedButton, .cgYellowButton, .cgLightGreyButton');
                    }
                    try {
                        //Keyboard focus to the cgRedButton because that's the default
                        theBtn.focus();
                    }
                    catch (e) { }
                }
            });

            dialogBox.html(message);

            //center the UI on the screen and make draggable.
            var outerDialog = $('.dialogRedWhiteGray');
            var dialogHeight = outerDialog.height();
            var dialogWidth = outerDialog.width();
            var dialogTop = (($(window).height() - dialogHeight) / 2) + "px";
            var dialogLeft = (($(window).width() - dialogWidth) / 2) + "px";
            outerDialog.css("top", dialogTop);
            outerDialog.css("left", dialogLeft);
            outerDialog.find('.ui-titlebar-image').remove(); //if we're reusing a div, we need to clean up.
            $('<div></div>').addClass("ui-titlebar-image").appendTo(outerDialog.children('.ui-dialog-titlebar'));

            return dialogBox;
        },

        isScrolledIntoView: function (element: { offset: () => { (): any; new(): any; top: any; }; height: () => any; }, scrollContainer: { offset: () => { (): any; new(): any; top: any; }; height: () => any; }) {

            var viewTop = scrollContainer.offset().top;
            var viewBottom = viewTop + scrollContainer.height();

            //compensate (roughly) for the horizontal scrollbar hiding data
            if (Cartegraph.Utilities.hasHorizontalScrollBar)
                viewBottom = viewBottom - 15;

            var elementTop = element.offset().top;
            var elementBottom = elementTop + element.height();

            return ((elementBottom <= viewBottom) && (elementTop >= viewTop));
        },

        hasHorizontalScrollBar: function (scrollContainer: JQuery) {
            var width = scrollContainer.width();
            var scrollWidth = scrollContainer.attr('scrollWidth') as any;

            return width < scrollWidth;
        },

        changeLabelDialog: function (options: any) {
            var defaults = {
                title: "",
                message: "",
                oldName: "",
                buttons: null as any,
                isAlert: false,
                value: ""
            }, opts;

            opts = $.extend(defaults, options);

            if (opts.buttons) {
                if (opts.isAlert) {
                    $.each(opts.buttons, function (_index, value) {
                        value["class"] = "btnSave";
                    });
                }
                else {
                    $.each(opts.buttons, function (index, value) {
                        if (index == "Cancel")
                            value["class"] = "btnCancel";
                        if (index == "Save")
                            value["class"] = "btnSave";
                    });
                }
            }

            if (opts.message) {
                opts.message = opts.message.replace(/\n/g, '<br />');
            }

            var dialogElement = $('#dialog');
            var entireDialog = $(dialogElement).parent();

            //This hooks up our common dialog and returns it read to be invoked
            var dialogBox = $(dialogElement).dialog({
                resizable: false,
                draggable: false,
                width: 475,
                modal: true,
                title: opts.title,
                autoOpen: true,
                buttons: opts.buttons,
                zIndex: 99999998,
                dialogClass: " dialogRedWhiteGray dialogChangeLabel",
                open: function () {
                    setTimeout(function () {
                        var input = dialogBox.find("input").first();
                        input.focus();

                        var buttons = $(entireDialog).find('.ui-dialog-buttonpane').find('[role="button"]');
                        buttons.attr('tabindex', '0');

                        $(buttons).focus(function () {
                            $(this).addClass('focused');
                        });

                        $(buttons).blur(function () {
                            $(this).removeClass('focused');
                        });


                        // Restrict tabbing to stay within tabbable elements on the form
                        entireDialog.delegate('input, textarea, [tabindex="0"]', 'keydown keypress', function (e) {

                            if (dialogBox.parent().is(':visible')) {

                                if (e.keyCode) {
                                    if (e.keyCode == $.ui.keyCode.ENTER) {
                                        if (input[0] == this) {
                                            $(buttons[1]).trigger('click');
                                            e.preventDefault();
                                        }
                                    }
                                    else if (e.keyCode == $.ui.keyCode.TAB) {

                                        var visibleFormInputs = dialogBox.parent().find('input:visible:not([readonly],[disabled]), textarea:visible:not([readonly],[disabled]), [tabindex="0"]:visible:not(.disabled)');

                                        if (visibleFormInputs.length > 0) {
                                            var firstInput = $(visibleFormInputs).first()[0];
                                            var lastInput = $(visibleFormInputs).last()[0];
                                            var currentInput = $(this)[0];

                                            var tabbingBackward = e.shiftKey ? true : false;

                                            if (currentInput === lastInput && !tabbingBackward) {
                                                setTimeout(function () { $(currentInput).removeClass('focused'); $(firstInput).focus(); }, 30);
                                                e.preventDefault();
                                            } else if (currentInput === firstInput && tabbingBackward) {
                                                setTimeout(function () { $(lastInput).focus(); }, 30);
                                                e.preventDefault();
                                            }
                                        }
                                    }
                                }
                            }
                        });
                    }, 10);
                },
                close: function () {
                    entireDialog.undelegate('input, textarea, [tabindex="0"]', 'keydown keypress');
                }
            });
            if (!opts.isAlert)
                dialogBox.html('<div id="dialogForm" ><div id="messageDiv">' + opts.message + '</div> <input id="NewSectionLabel" class="text-box" type="text" value="' + opts.oldName + '"/></div>');
            else
                dialogBox.html('<div id="Alert">' + opts.message + '</div>');

            if (opts.value) {
                dialogBox.find("#NewSectionLabel").val(opts.value);
            }

            //center the UI on the screen and make draggable.
            var outerDialog = $('.dialogChangeLabelOuter');
            var dialogHeight = outerDialog.height();
            var dialogWidth = outerDialog.width();
            var dialogTop = (($(window).height() - dialogHeight) / 2) + "px";
            var dialogLeft = (($(window).width() - dialogWidth) / 2) + "px";
            outerDialog.css("top", dialogTop);
            outerDialog.css("left", dialogLeft);
            return dialogBox;
        },
        errorDialog: function (title: string, message: string, closeWindow: any, callback: () => void) {

            var buttons = {
                "OK": { text: Cartegraph.Resources.OK,
                    click: function () {
                        $(this).dialog("close");
                        Cartegraph.Utilities.removeWaitScreen();
                        if (closeWindow) {
                            // The first line prevents IE from giving you the messagebox for the page trying to close the tab.
                            window.open('', '_self', '');
                            window.close();
                        }
                        if (callback && typeof callback === 'function') {
                            callback();
                        }
                    },
                    defaultButton: true
                }
            };
            return Cartegraph.Utilities.initDialog(title, message, buttons, false);
        },
        warningDialogSaveChanges: function (title: string, message: string, cancelText: string, okText: string, closeWindow: boolean, callback: () => void) {
            var buttons = {
                "Cancel": { text: cancelText,
                    click: function () {
                        $(this).dialog("close");
                        Cartegraph.Utilities.removeWaitScreen();
                        if (closeWindow) {
                            // The first line prevents IE from giving you the messagebox for the page trying to close the tab.
                            window.open('', '_self', '');
                            window.close();
                        }
                        return false;
                    },
                    defaultButton: false
                },
                "OK": { text: okText,
                    click: function () {
                        $(this).dialog("close");
                        Cartegraph.Utilities.removeWaitScreen();

                        if (closeWindow) {
                            // The first line prevents IE from giving you the messagebox for the page trying to close the tab.
                            window.open('', '_self', '');
                            window.close();
                        }
                        if (callback && typeof callback === 'function') {
                            callback();
                        }
                        return true;
                    },
                    defaultButton: true
                }
            };
            return Cartegraph.Utilities.initDialog(title, message, buttons, true);
        },

        warningDialogOK: function (title: string, message: string, closeWindow: boolean) {
            var buttons = {
                "OK": { text: Cartegraph.Resources.OK,
                    click: function () {
                        $(this).dialog("close");
                        Cartegraph.Utilities.removeWaitScreen();
                        if (closeWindow) {
                            // The first line prevents IE from giving you the messagebox for the page trying to close the tab.
                            window.open('', '_self', '');
                            window.close();
                        }
                        return false;
                    },
                    defaultButton: true
                }
            };
            return Cartegraph.Utilities.initDialog(title, message, buttons, true);
        },

        /** Call this one if you want to include the JS each and every time.
        * You might calls this in the case where you know the JS loaded from the
        * file's namespace is blown away each time. */
        includeJS: function (url: string, scriptId: any, callbackFunction: any) {
            // Add a new pocket if it's for a create process being launched
            Cartegraph.FormModel.addCreatePocket();
            ($.getScript as any)(url, scriptId, callbackFunction);
        },

        invalidateMapCache: function () {
            mapCacheId++;
            if (mapCacheId >= 2147483647)   // Circle back around to avoid overflow
                mapCacheId = -2147483647;
        },

        getMapCacheId: function () {
            return mapCacheId;
        },

        /**
        * This will get the Scrollbar width of the current OS.
        * We only do this code once and store him off. So,
        * There should be no performance issues with this code
        */
        getScrollBarWidth: function () {

            if (scrollbarWidth != null)
                return scrollbarWidth;

            //Default it to something smart just in case our get scroll width function fails.
            try {
                var inner = document.createElement('p');
                inner.style.width = "100%";
                inner.style.height = "200px";

                var outer = document.createElement('div');
                outer.style.position = "absolute";
                outer.style.top = "0px";
                outer.style.left = "0px";
                outer.style.visibility = "hidden";
                outer.style.width = "200px";
                outer.style.height = "150px";
                outer.style.overflow = "hidden";
                outer.appendChild(inner);

                document.body.appendChild(outer);
                var w1 = inner.offsetWidth;
                outer.style.overflow = 'scroll';
                var w2 = inner.offsetWidth;
                if (w1 == w2) w2 = outer.clientWidth;

                document.body.removeChild(outer);

                scrollbarWidth = (w1 - w2);
            }
            catch (e) {

                scrollbarWidth = 17; //Default if there is ever a failure. At least it set to something smart.
            }
            return scrollbarWidth;
        },

        getBaseURL: function () {
            return getBaseURL();
        },

        getHash: function () {
            if (window.location.href.split("#").length > 1)
                return window.location.href.split("#")[1]; //location.hash.replace('#', ''); Does not work in FireFox, as Firefox removes URI encoding!
            else
                return "";
        },

        random4() {
            return (((1+Math.random())*0x10000)|0).toString(16).substring(1);
        },

        getNewGuid() {
            return (this.random4() + this.random4() + "-" + this.random4() + "-4" + this.random4().substr(0,3) + "-" + this.random4() + "-" + this.random4() + this.random4() + this.random4()).toLowerCase();
        },

        isJson(testString: string) {
            try {
                JSON.parse(testString);
            } catch (e) {
                return false;
            }
            return true;
        },

        createQtipError(errorId: string, position: { my: any; at: any; adjust: any; maxWidth?: any; }) {
            var myScrollfunction = function () {
                $("[id='" + errorId + "']").qtip('toggle');
            };

            var buildToolTipMessage = function(messageText: string) {
                var yieldImage = "<span class='ui-tooltip-left-side-content' />";
                var buttonImage = "<span class='ui-tooltip-right-side-content' />";
                return yieldImage + '<div class="ui-tooltip-message-content">' + messageText + '</div>' + buttonImage;
            }

            if(!position) {
                position = {
                    my: "bottom center",
                    at: "top center",
                    adjust: {
                        y: -1,
                        x: -1
                    },
                }
            }

            var qTipOptions = {
                    content: {
                        text: function () {
                            return "";
                        }
                    },
                    style: {
                        classes: 'ui-tooltip-red',
                        tip: {
                            corner: true,
                            width: 24,
                            height: 12
                        },
                        width: undefined as number
                    },
                    position: {
                        my: position.my,
                        at: position.at,
                        adjust: position.adjust,
                        viewport: $(window)
                    },
                    events: {
                        visible: function (_event: any, api: any) {
                            $(api.elements.content).find('.ui-tooltip-right-side-content').unbind('click').bind('click', function () {
                                api.toggle();
                            });
                        },
                        show: function (event: any, api: any) {
                            var errorTile = $(api.elements.target).children('span:first');

                            $("[id='" + errorId + "']").scrollParent().bind('scroll', myScrollfunction);

                            //We don't have a error so don't show.
                            if (errorTile && errorTile.length <= 0) {
                                try { event.preventDefault(); } catch (e) { } //Eat exception because IE
                            }
                            else
                                api.set('content.text', buildToolTipMessage(errorTile.text())); //Set the tip with a fresh error.
                        },
                        hide: function () {
                            $("[id='" + errorId + "']").scrollParent().unbind('scroll', myScrollfunction);
                        }
                    },
                    show: {
                        event: "click"
                    },
                    hide: "unfocus"
                }

                if(position.maxWidth)
                    qTipOptions.style.width = position.maxWidth;

                $("[id='" + errorId + "']").qtip(qTipOptions);

        },

        getModalPosition(modalId: string) {

            var modal = $("#" + modalId);
            var container = $("#" + modalId).closest(".blockScreenWidgetModal");

            return {
                width: modal.width(),
                height: modal.width(),
                zIndex: modal.zIndex(),
                top: Math.round(container.css("top").replace("px","") as any),
                right: Math.round(container.css("right").replace("px","") as any),
                bottom: Math.round(container.css("bottom").replace("px","") as any),
                left: Math.round(container.css("left").replace("px","") as any),
            }
        },


        updateControl: function (element: any) {
            //For multi-combo, so that when things are dropped down we don't fire the validation logic.
            if ($(element).hasClass("ui-autocomplete-input")) {
                var dropDownId = "#grid" + $(element).attr('id') + "Div"; //This is the container div id for the drop down
                //if($(dropDownId).is(":visible"))
                if ($(dropDownId).position() && (!($(dropDownId).position().top == -50000 || $(dropDownId).position().top == 0)))
                    return true; //Pop up is still open. So, ignore this for validation.
            }

            // if the control is a text or memo field, trim leading and trailing spaces before validation.
            if ($(element).hasClass('text-box') && !$(element).hasClass('numeric') && !$(element).hasClass('password'))
                $(element).val($.trim($(element).val() as string));

            // if the control is a date value, or has a child that is a date value such as the report screen prompts,
            // attempt to parse its value as a date and ninja-switch the formatted value into place if parsing is successful
            // if the date control is open, don't parse the value, to avoid problems with locking up the month and year dropdowns
            if ($(element).hasClass('date-field') || $(element).find('.date-field').length > 0) {
                if (!$.datepicker._datepickerShowing) {
                    try {
                        var parsedDate = Cartegraph.DateTimeUtilities.smartDate($(element).val());

                        if (parsedDate)
                            $(element).val($.datepicker.formatDate(Cartegraph.Resources.LegacyDateFormat, parsedDate));
                    }
                    catch (e) {
                        return false;
                    }
                }
                else // date picker is open, so get out without doing any validation
                    return true;
            }

            // Smart Time
            // If the control is a time value, or has a child that is a time value such as the report screen prompts,
            // attempt to parse its value and ninja-switch the formatted value into place if parsing is successful
            if (($(element).hasClass('time-box') || $(element).find('.time-box').length > 0) && !$(element).hasClass('input-validation-error')) {
                try {
                    var parsedTime = Cartegraph.DateTimeUtilities.parseTime($(element).val());
                    if (parsedTime)
                        $(element).val(parsedTime);
                }
                catch (e) {
                    return false;
                }
            }

            // if the control is a date time value, or has a child that is a date time value such as the report screen prompts,
            // attempt to parse the first part of its value as a date and ninja-switch the formatted value into place if parsing is successful
            // attempt to parse the second part of its value and ninja-switch the formatted value into place if parsing is successful
            // if the control is open, don't parse the value, to avoid problems with locking up the control's dropdowns
            if ($(element).hasClass('dateTime-field') || $(element).find('.dateTime-field').length > 0) {
                if (!$.datepicker._datepickerShowing) {
                    try {
                        var dateTimeValue = ($(element).val() as string).replace(/^\s+|\s+$/g, ''); //trim leading and trailing whitespaces
                        var endOfDateValue = dateTimeValue.indexOf(" "); //assume the first space found in the value is the end of the date value
                        var parsedDateTime;
                        if (endOfDateValue > 0) {
                            //assume first part date and second part time
                            var tempDate = Cartegraph.DateTimeUtilities.smartDate(dateTimeValue.substring(0, endOfDateValue));
                            var tempTime = Cartegraph.DateTimeUtilities.parseTime(dateTimeValue.substring(endOfDateValue + 1).replace(/^\s+|\s+$/g, ''));

                            if (tempDate && tempTime) {
                                //convert tempDate from Date to string of only its date portion so we can add on the time
                                //then convert the full value back to a date
                                parsedDateTime = new Date(tempDate.toDateString() + " " + tempTime);
                            }
                        }
                        else {//assume date
                            parsedDateTime = Cartegraph.DateTimeUtilities.smartDate(dateTimeValue);
                        }

                        if (parsedDateTime) {
                            var date = $.datepicker.formatDate(Cartegraph.Resources.LegacyDateFormat, parsedDateTime);
                            var hours = parsedDateTime.getHours();
                            var minutes = parsedDateTime.getMinutes() as any;
                            var seconds = parsedDateTime.getSeconds() as any;
                            var suffix = Cartegraph.Resources.AM;

                            if (hours >= 12) {
                                suffix = Cartegraph.Resources.PM;
                                hours = hours - 12;
                            }

                            if (hours == 0) {
                                hours = 12;
                            }

                            if (minutes < 10)
                                minutes = "0" + minutes;

                            if (seconds < 10)
                                seconds = "0" + seconds;

                            $(element).val(date + " " + hours + ":" + minutes + ":" + seconds + " " + suffix);
                        }
                    }
                    catch (e) {
                        return false;
                    }
                }
                else // date picker is open, so get out without doing any validation
                    return true;
            }

            //If the control is not a numeric field allow the validation to fire.
            //Numeric fields will be validated as part of autoNumeric.js
            if (!$(element).hasClass('text-box numeric'))
                if (Cartegraph.ValidationHelpers.islegacyValidationSetup($(element)))
                    $(element).valid();

            if ($(element).hasClass('ui-autocomplete-input') && $(element).hasClass('input-validation-error')) {
                $(element).removeClass('input-validation-error');
                $(element).parent().addClass('lookup-error');
            }
        },

        setupControlWidgets: function (scrollContainer: any, controlsContainer: string, dropDownsContainer: any, savable: any, basePath: any, updateViewControls: any, isQTip: any, autoId: any, autoIdLookupOnly: any) {
            if (controlsContainer)
                controlsContainer = controlsContainer + ' ';

            $(controlsContainer + '.boolean-control').BooleanControl({ updateViewControls: updateViewControls, autoId: autoId || false });
            $(controlsContainer + '.currency-control').CurrencyControl({ updateViewControls: updateViewControls, autoId: autoId || false });
            $(controlsContainer + '.date-control:not(.ko-flex)').DateControl({ ScrollContainer: scrollContainer, container: dropDownsContainer, savable: savable, updateViewControls: updateViewControls, autoId: autoId || false });
            $(controlsContainer + '.date-time-control:not(.ko-flex)').DateTimeControl({ ScrollContainer: scrollContainer, container: dropDownsContainer, savable: savable, updateViewControls: updateViewControls, autoId: autoId || false });
            $(controlsContainer + '.double-control, .quantity-amount-control').DoubleControl({ updateViewControls: updateViewControls, autoId: autoId || false });
            $(controlsContainer + '.date-integer-control').IntegerControl({ Max: '1999', Min: '-1999', updateViewControls: updateViewControls, autoId: autoId || false });
            $(controlsContainer + '.integer-control').IntegerControl({ updateViewControls: updateViewControls, autoId: autoId || false });
            $(controlsContainer + '.required-integer-control').IntegerControl({ updateViewControls: updateViewControls, autoId: autoId || false, emptyStringIsNumeric: false });
            $(controlsContainer + '.quantity-unit-control').QuantityUnitControl({ container: dropDownsContainer, ScrollContainer: scrollContainer, updateViewControls: updateViewControls, autoId: autoId || false });
            $(controlsContainer + '.string-control').StringControl({ updateViewControls: updateViewControls, autoId: autoId || false });
            $(controlsContainer + '.time-control').TimeControl({ ScrollContainer: scrollContainer, BasePath: basePath, container: dropDownsContainer, savable: savable, updateViewControls: updateViewControls, autoId: autoId || false });
            $(controlsContainer + '.multi-line').MultilineTextControl({ autoId: autoId || false });
            $(controlsContainer + '.filter-control').FilterControl({ autoId: autoId || false });
            $(controlsContainer + '.libraryAttachment.editAttachment').each(function () {
                var self = $(this);
                self.libraryAttachment({ className: self.data('class-name'), fieldName: self.data('field-name') });
            });

            //Hookup the lookups!
            $(controlsContainer + '.readonlylookup').ReadonlyLookupControl({ autoId: autoId || false });
            $(controlsContainer + ".lookup-box:not(.readonlylookup):not(.datetime-box):not(.time-box)").each(function () {
                var self = $(this);
                var filter = self.attr("navFilter");
                var targetFieldUid = '';

                if (self.hasClass('text-lookup-control')) {
                    targetFieldUid = self.attr("fieldname");
                }

                self.LookupControl({
                    targetClassName: self.attr("classname"),
                    closeWhenScrolling: scrollContainer,
                    targetFieldUid: targetFieldUid,
                    container: dropDownsContainer,
                    BasePath: basePath,
                    updateViewControls: updateViewControls,
                    isQTip: isQTip,
                    filter: filter,
                    autoId: autoId || autoIdLookupOnly || false
                });
            });
        },

        showWaitScreen: function (message: string, time: number) {
            // If there was a timeout set by a previous call that wasn't cleared out before the second call to showWaitScreen, clear the timeout
            if (timeout)
                clearTimeout(timeout);

            var spinner = $('#waitSpinnerOverlay');
            spinner.css("visibility", "visible");

            if (message)
                spinner.find(".waitMessage").html(message);

            if (time == null)
                time = 1000;

            var timeoutFunction = function () {
                spinner.children().css("visibility", "visible");
                $('.ui-jqgrid div.loading:visible').hide();
            };

            timeout = setTimeout(timeoutFunction, time);
        },

        setWaitScreenMessage: function (message: string) {
            $('#waitSpinnerOverlay').find('.waitMessage').html(message);
        },

        WaitScreenVisible: function () {
            return $('#waitSpinnerOverlay').css('visibility')?.toLowerCase() == 'visible';
        },

        waitSpinnerInterval: null as any,

        removeWaitScreen: function () {
            clearTimeout(timeout);
            $('#waitSpinnerOverlay').css("visibility", "hidden").children().css("visibility", "hidden");

            clearInterval(Cartegraph.Utilities.waitSpinnerInterval);
        },

        // event handler to suppress keyboard/mouse events when blocking
        blockScreenTabHandler: function (e: any) {
            // allow tab navigation (conditionally)
            if (blockTabs) {
                if (e.keyCode && e.keyCode == 9) {

                    //firstItem and lastItem can change based on if the control is disabled or not.
                    var firstItem = $(firstTabbableItem);
                    if (firstItem.hasClass("disabled"))
                        firstItem = firstItem.next().is(':focusableControl') ? firstItem.next() : firstItem.next().find(':focusableControl').first();

                    var lastItem = $(lastTabbableItem);
                    if (lastItem.hasClass("disabled"))
                        lastItem = lastItem.prev().is(':focusableControl') ? lastItem.prev() : lastItem.prev().find(':focusableControl').last();

                    //are we tabbing too far forward or are we tabbing to something outside of the blockscreen?
                    var fwd = (!e.shiftKey && $(e.target)[0] == (lastItem[0])) || $(e.target).parents('#' + blockScreenId).length == 0;

                    //are we tabbing too far backward?
                    var back = e.shiftKey && $(e.target)[0] == (firstItem.first()[0]);

                    if (fwd) {
                        //if we tabbed too far, focus on the first input again.
                        setTimeout(function () {
                            firstItem.first().focus();
                        }, 10);
                        return false;
                    }
                    else if (back) {
                        //if we tabbed back too far, focus on the last button.
                        setTimeout(function () {
                            lastItem[0].focus();
                        }, 10);
                        return false;
                    }

                    return true;
                }
            }
            return true;
        },

        showBlockWidget: function (options: { transparentOverlay: any; hideBlockOverlay: boolean; }) {

            // Default options
            var defaults = {
                transparentOverlay: false,
                hideBlockOverlay: false
            };

            // Merge passed in options with defaults
            options = $.extend(true, defaults, options); // True means deep copy

            // add the overlay
            var transparentClass = options.transparentOverlay ? "transparent-overlay" : "";
            var blockOverlay = $('<div class="blockScreenWidgetOverlay ' + transparentClass + '"></div>');

            if (options.hideBlockOverlay === true) {
                blockOverlay.css('visibility', 'hidden');
            }

            blockOverlay.appendTo($('body'));

            // attach the widget
            var overlayWidget = blockOverlay.cgBlockScreen(options);
            return overlayWidget.cgBlockScreen('getWidgetModal');
        },

        removeLastBlockWidget: function () {

            $('.blockScreenWidgetOverlay').last().remove();
            $('.blockScreenWidgetModal').last().remove();
        },

        hidePreviousBlockScreen: function (show: boolean) {
            var overlay = $('.blockScreenWidgetOverlay');
            var modal = $('.blockScreenWidgetModal');

            //-2 because you don't want the current screen, but the one before last.
            if (overlay.length >= 2 && modal.length >= 2) {
                var previousOverlay = $(overlay[overlay.length - 2]);
                var previousModal = $(modal[modal.length - 2]);

                show ? previousOverlay.show() : previousOverlay.hide();
                show ? previousModal.show() : previousModal.hide();
            }
        },

        revealPreviousBlockScreen: function () {
            Cartegraph.Utilities.hidePreviousBlockScreen(true);
        },

        //Remove the block widget containing a given JQuery element.
        removeCurrentBlockWidget: function (element: JQuery) {
            if (Cartegraph.Utilities.isNullOrUndefined(element) && element.length <= 0)
                return;

            element.prev('.blockScreenWidgetOverlay').remove();
            element.remove();
        },

        showBlockScreen: function (html: string, firstItem: any, lastItem: any, blkScreenId: any, preventTabs: boolean) {
            var blockScreen = $('#blockScreen');
            $('#blockScreenOverlay').css("visibility", "visible").show();
            blockScreen.css("visibility", "visible");
            if (html)
                blockScreen.html(html);

            var events = 'keydown.BlockScreen keypress.BlockScreen';
            firstTabbableItem = firstItem;
            lastTabbableItem = lastItem;
            blockTabs = preventTabs;
            blockScreenId = blkScreenId;
            $(document).bind(events, this.blockScreenTabHandler);
        },

        removeBlockScreen: function () {
            var $block = $('#blockScreenOverlay');
            var $blockScreen = $('#blockScreen');
            $block.css("visibility", "hidden");
            $blockScreen.css("visibility", "hidden");
            $blockScreen.html("");
            var events = 'keydown.BlockScreen keypress.BlockScreen';
            $(document).unbind(events);
        },

        //Sets a jQuery blockUI element over the #topNav div
        blockTopNav: function () {
            if ($('#topNav').length)
                $('#topNav').block({ message: null, overlayCSS: { cursor: 'default'} });
        },

        //Removes the jQuery blockUI element from over the #topNav div
        unblockTopNav: function () {
            if ($('#topNav').length)
                $('#topNav').unblock();
        },

        sidebarEditableState: function (section: string, editing: any) {
            $.each($('.sidebarElement'), function () {
                var sectionName = $(this).attr('section');
                //Don't allow corresponding sidebar to be unchecked while you are editing.
                if (editing && sectionName.toLowerCase() == section.toLowerCase()) {
                    $(this).children('.sidebarCheckbox').children(0 as any).attr('disabled', true as any);
                }
                else {
                    $(this).children('.sidebarCheckbox').children(0 as any).attr('disabled', false as any);
                }
            });
        },
        compileTemplates: function (tmplIds: string | string[]) {
            if ($.isArray(tmplIds)) {
                $.each(tmplIds, function (_i, template) {
                    addTemplate(template);
                });
            } else if (typeof tmplIds === 'string') {
                addTemplate(tmplIds);
            }

            function addTemplate(templateId: string) {
                templateId = templateId.indexOf('#') === -1 ? templateId : templateId.substr(1); //strip off the '#' if present

                $('#' + templateId).template(templateId);
            }
        },
        getAuthorizedClassesForView: function (viewType: any, callback: (arg0: any[]) => void) {
            $.ajax({
                url: AjaxURL.FlexUI("GetAssetsAuthorizedForView"),
                type: 'GET',
                dataType: "json",
                data: JSON.stringify({ viewType: viewType }),
                success: function (data) {
                    callback(data);
                },
                error: function () {
                    callback([]);
                }
            });
        },
        array_unique: function (ar: any) {
            if (ar.length && typeof ar !== 'string') {
                var sorter = {} as any;
                var out = [];
                for (var i = 0, j = ar.length; i < j; i++) {
                    if (!sorter[ar[i] + typeof ar[i]]) {
                        out.push(ar[i]);
                        sorter[ar[i] + typeof ar[i]] = true;
                    }
                }
            }
            return out || ar;
        },

        //This method is called before a lot of ajax calls to check if you are currently timed out.
        // In the future, we would like to refactor to make this function called only in the beforeSend
        // event on our custom .ajax override.  This would eliminate the need for everyone else to call it.
        isSessionTimedOut: function () {
            return !Cartegraph.TimeoutService.isSessionActive();
        },

        taskOpenStatuses: function() {
            return [Cartegraph.Resources.TaskStatus.Planned, Cartegraph.Resources.TaskStatus.InProgress];
        },

        isOpenTaskStatus: function (status: string) {
            var openStatuses = _.map(this.taskOpenStatuses(), function(openStatus) {
                 return openStatus.toUpperCase();
            });
            return _.contains(openStatuses, status.toUpperCase());
        },

        workOrderOpenStatuses: function () {
            return [Cartegraph.Resources.WorkOrderStatus.Planned, Cartegraph.Resources.WorkOrderStatus.InProgress];
        },

        isOpenWorkOrderStatus: function (status: string) {
            var openStatuses = _.map(this.workOrderOpenStatuses(), function (openStatus) {
                return openStatus.toUpperCase();
            });
            return _.contains(openStatuses, status.toUpperCase()) || status === "";
        },

        htmlEncode: function (value: string) {
            return $('<div/>').text(value).html();
        },

        htmlDecode: function (value: string) {
            return $('<div/>').html(value).text();
        },

        urlEncodeSingleQuote: function(value: string) {
            return value.replace(/'/g, "%27");
        },

        trueClassesTargetList: function (targetList: ArrayLike<any>)
        {
            if (!$.isArray(targetList)) {
                return targetList;
            }

            var utils = this;
            var newList = new Array();
            $.each(targetList, function(_index, item) {
                var oid = utils.getOid(item);
                var className = Cartegraph.MetaDataHelpers.trueClassOfShare(utils.getClassname(item));
                newList.push(className + oid);
            });

            return newList;
        },

        generateClassNameOidObject: function(list: any[]) {
            var objectList: { className: any; oid: any; }[] = [];
            _.each(list, function (item) {
                var className = Cartegraph.Utilities.getClassname(item as string);
                var oid = Cartegraph.Utilities.getOid(item as string);
                objectList.push({ className: className, oid: oid });
            });

            return objectList;
        },

        getClassname: function (classAndOid: string) {
            var classPos = classAndOid.lastIndexOf("Class");
            return classAndOid.substr(0, classPos + 5);
        },

        getOid: function (classAndOid: string) {
            var classPos = classAndOid.lastIndexOf("Class");
            return classAndOid.substr(classPos + 5);
        },

        getOids: function (classesAndOids: string | any[]) {
            var oids = [];
            for (var i = 0; i < classesAndOids.length; i++) {
                oids.push(Cartegraph.Utilities.getOid(classesAndOids[i]));
            }
            return oids;
        },
        hasReportPermissions: function () {
            var hasPermission = true;

            var $layers = $('.layersContainer div.sidebar-layer');

            if (Cartegraph.URIMapper.isOnIndex()) {
                var allDenied = true;
                $layers.each(function () {
                    var $layer = $(this);
                    var layerClass = $layer.data('class-name');
                    if (layerClass != undefined && layerClass != '') {
                        var layerHasPermission = Cartegraph.Security.RuleSecurity.canDoAction(layerClass, 'RunReportAction');
                        if ($layer.find('.sidebar-layer-title.active').length > 0) {
                            if (!layerHasPermission)
                                hasPermission = false;
                        }

                        if (layerHasPermission)
                            allDenied = false;
                    }
                });

                if (Cartegraph.Filtering.Utilities.getLayerCounts() == 0)
                    allDenied = false;

                hasPermission = hasPermission && !allDenied;
            }

            if (Cartegraph.URIMapper.isOnDetail()) {
                var editClass = Cartegraph.CurrentAsset.getClass();
                if (editClass != undefined && !Cartegraph.Security.RuleSecurity.canDoAction(editClass, 'RunReportAction'))
                    hasPermission = false;
            }

            return hasPermission;
        },

        isNullOrUndefined: function (val: any) {
            return _.isNull(val) || _.isUndefined(val);
        },

        isNullUndefinedOrEmpty: function (val: string) {
            return _.isNull(val) || _.isUndefined(val) || _.isEmpty(val) || val == "\0";
        },

        arraysContainDifferentValues: function (array1: any[], array2: any[]) {
            var difference = _.difference(array1, array2);

            if (difference.length > 0) {
                return true;
            }

            difference = _.difference(array2, array1);

            if (difference.length > 0) {
                return true;
            }

            return false;
        },

        objectNameToString: function (objectsNamespace: { [x: string]: any; }, objectLocation: any) {

            if (Cartegraph.Utilities.isNullOrUndefined(objectsNamespace)
                || Cartegraph.Utilities.isNullOrUndefined(objectLocation)
                || !_.isObject(objectsNamespace)
                || !_.isObject(objectLocation)) {

                throw new Error("Both objectsNamespace and objectLocation, of type object, are required");
            }

            for (var o in objectsNamespace) {
                if (objectsNamespace[o] === objectLocation)
                    return o;
            }

            throw new Error("objectNameToString could not find name!");
        },

        setLookupFilter: function (params: any) {

            var defaults = {
                containerId: null as string,
                propertyName: null as string,
                filter: ""
            };

            var options = $.extend(defaults, params);

            if (options.containerId == null || options.propertyName == null)
                return;

            $(String.Format("#{0} #{1}", options.containerId, options.propertyName)).autocompletegrid('option', 'filter', options.filter);
        },

        formatNumber: function (decimalValue: string) {
            var numberParts = decimalValue.split('.');
            if (parseInt(numberParts[1]) > 0)
                return decimalValue;

            return numberParts[0];
        },

        formatSize: function (bytes: number) {
            var i = -1;
            do {
                bytes = bytes / 1024;
                i++;
            } while (bytes > 999);

            return Math.max(bytes, 0.1).toFixed(1) + ' ' + ['KB', 'MB', 'GB', 'TB', 'PB', 'EB'][i];
        },

        redirectToLogin: function () {
            if (Cartegraph.ProceedIfNotDirty && Cartegraph.URIMapper) {
                Cartegraph.ProceedIfNotDirty.message(function () {
                    window.location = location.pathname + 'Account/ShowSignIn' + (Cartegraph.URIMapper.isOnInternalRequest() ? '?isInternalRequest=True' : '') as any;
                });
            } else {  // the report viewer doesn't need the above checks and additional source files in it's bundle
                window.location = getBaseURL() + 'Account/ShowSignIn' as any;
            }
        },
        sessionTimeout: function () {
            let newLocation: string;
            const searchParams = new URLSearchParams({
                timedOut: 'True',
                // We want to mimic what ASP.NET would do for the return URL so that we can come back to the same place after sign in
                ReturnUrl: window.location.pathname + window.location.search
             });
            if (Cartegraph.URIMapper) {
                newLocation = location.pathname;
                if (Cartegraph.URIMapper.isOnInternalRequest())
                    searchParams.set('isInternalRequest', 'True');
            } else { // the report viewer doesn't need the above checks and additional source files in it's bundle
                newLocation = getBaseURL();
            }

            newLocation += 'Account/ShowSignIn';


            // Preserving the hash allows us to redirect back to wherever we kicked you out
            window.location.href = newLocation + '?' + searchParams.toString() + location.hash;
        },
        focusInput: function (element: any) {
            if (element.length) {
                element.attr("tabindex", 0);
                _.defer(function () {
                    element.focus();
                    // Webkit browsers highlight the entire field's content when focus is set.
                    // Move the insertion point to the beginning to be consistent with other browsers. Except boolean controls.
                    var $element = $(element[0]);
                    var isTextInput = !$element.hasClass("boolean-control") && $element.attr('type') != "checkbox" && $element.attr('type') != 'file';
                    if ($.browser.webkit && isTextInput) {
                        $element[0].setSelectionRange(0, 0);
                    }
                });
            }
        },
        scrollToTop: function (currPage: JQuery) {
            // For Assets created via the guided process if the window was not fully displayed the map was not being
            // displayed since focus was applied to the first enterable field (therefore causing scrolling of page)
            if (currPage) {
                _.defer(function () {
                    // scrollTop not working unless detailSection was hidden and redisplayed
                    currPage.find('.cgDetailSection').hide();
                    currPage.scrollTop(0);
                    currPage.find('.cgDetailSection').show();
                });
            }
        },
        copyToClipboard: function(text: string) {
            var el = document.createElement('textarea');
            el.value = text;
            el.setAttribute('readonly', '');
            (el.style as any) = { position: 'absolute', left: '-9999px' };
            document.body.appendChild(el);
            el.select();
            document.execCommand('copy');
            document.body.removeChild(el);
        },
        waitForElement: function (childSelector: string) {
            return new Promise(result => {
                if (document.querySelector(childSelector)) {
                    return result(document.querySelector(childSelector));
                }

                const observer = new MutationObserver(() => {
                    if (document.querySelector(childSelector)) {
                        result(document.querySelector(childSelector));
                        observer.disconnect();
                    }
                });

                observer.observe(document.body, {
                    childList: true,
                    subtree: true
                });
            });
        }
    };

})();

return Cartegraph;
}
